module.exports = __webpack_public_path__ + "static/Mittelrhein2-scaled-0d32f1a983700c2aba45d67e82246e46.jpeg";